import { makeStyles } from '@material-ui/core';

export const cmpStyle = makeStyles((theme) => ({
  root: {
    width: '56px',
    height: '56px',
    backgroundColor: theme.colors.Primary,
    borderRadius: '50%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
